module.exports = "/lucky-balls/img/infobox/info_Box_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_014.png
// module id = 1079
// module chunks = 0